import { faXmark } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { imageViewerAtom } from "@mirage/hooks/useImageViewer";
import { Button, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import Field from "../regularField/Field";

export const ImageViewer = () => {
    const [state, set] = useRecoilState(imageViewerAtom);
    const [visible, setVisible] = useState(false);
    const [localOptions, setLocalOptions] = useState(state.options);
    const { base64, onClose, options } = state;
    useEffect(() => {
        setVisible(!!base64);
        setLocalOptions(options);
        setDescription(options?.description || "");
    }, [base64, options]);

    const className = visible ? "" : "container--hidden";
    const fullWindowModifier = "popupContainer--fullWindow";
    const viewerStyle = localOptions ? { width: "calc(100% - 300px)" } : ({ width: "100%" } as React.CSSProperties);
    viewerStyle.backgroundColor = "#f2f2f2";

    const closeButton = (
        <Button variant="outlined" onClick={onCloseClicked}>
            Close
        </Button>
    );
    const saveButton =
        localOptions && localOptions.readonly ? null : (
            <Button variant="contained" onClick={onSaveClicked}>
                Save
            </Button>
        );
    const [description, setDescription] = useState(localOptions?.description || "");
    const isReadonly = localOptions?.readonly || false;
    const detailsPanel = localOptions ? (
        <div style={{ width: "300px", padding: "10px", backgroundColor: "#fff", boxShadow: "-11px 0px 23px -16px rgba(66, 68, 90, 1)" }}>
            <Field containerClassName="miragePanelFieldContainer" label="Name" value={localOptions.name} mode="view" contentType="TEXT" />
            <Field containerClassName="miragePanelFieldContainer" label="Last modified" value={localOptions.lastModified} mode="view" contentType="TEXT" />
            <Field containerClassName="miragePanelFieldContainer" label="Size" value={localOptions.size} mode="view" contentType="TEXT" />
            <Field containerClassName="miragePanelFieldContainer" label="Creator" value={localOptions.creator} mode="view" contentType="TEXT" />
            <Field
                containerClassName="miragePanelFieldContainer"
                label="Description"
                value={description}
                onChange={(e, value) => {
                    setDescription(value);
                }}
                mode={isReadonly ? "view" : "edit"}
                contentType={"TEXTAREA"}
            />
            <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                {saveButton}
                {closeButton}
            </div>
        </div>
    ) : null;

    return (
        <div className={`popupContainer ${fullWindowModifier} ${className}`}>
            <div className="container__toolBar container__toolBar--rightAligned">
                <Tooltip title="Close">
                    <FontAwesomeIcon className="container__pointerIcon" icon={faXmark} onClick={onCloseClicked} />
                </Tooltip>
            </div>
            <div className="container--fullHeight" style={{ display: "flex" }}>
                <div style={viewerStyle}>
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            backgroundImage: `url(${base64})`,
                            backgroundPosition: "center",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                        }}
                    ></div>
                </div>
                {detailsPanel}
            </div>
        </div>
    );
    function onCloseClicked() {
        onClose();
    }
    function onSaveClicked() {
        onClose(description);
    }
};
